"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportType;
(function (ReportType) {
    ReportType["Error"] = "error";
    ReportType["Warn"] = "warn";
    ReportType["Info"] = "info";
    ReportType["Trace"] = "trace";
    ReportType["Debug"] = "debug";
    ReportType["Entry"] = "entry";
    ReportType["Exit"] = "exit";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
const _defaultConfig = {
    colors: {
        error: '#f2777a',
        warn: '#ffcc66',
        info: '#99cc99',
        trace: '#6699cc',
        debug: '#66cccc',
        entry: '#EB3F39',
        exit: '#EB3F39',
    },
};
const _defaultMetaData = {
    app: 'logger-console',
    appVersion: '1.0.0',
    project: 'vlinder',
    projectVersion: '1.0.0',
};
class ConsoleLogger {
    constructor(module, isDEV = true, metadata = _defaultMetaData, config = _defaultConfig) {
        this.module = module;
        this.isDEV = isDEV;
        this.metadata = metadata;
        this.config = config;
        this.name = 'console';
    }
    error(report) {
        this.printReport(report, ReportType.Error);
    }
    trace(report) {
        this.printReport(report, ReportType.Trace);
    }
    info(report) {
        this.printReport(report, ReportType.Info);
    }
    warn(report) {
        this.printReport(report, ReportType.Warn);
    }
    exit(report) {
        this.printReport(report, ReportType.Exit);
    }
    entry(report) {
        this.printReport(report, ReportType.Entry);
    }
    debug(report) {
        this.printReport(report, ReportType.Debug);
    }
    printReport(report, type) {
        if (this.isDEV) {
            let _metaData;
            let _css;
            let _reportCss;
            let _report = report;
            if (type == ReportType.Entry) {
                _report = `|-> ${_report}`;
            }
            if (type == ReportType.Exit) {
                _report = `<-| ${_report}`;
            }
            _metaData = ConsoleLogger.buildMetaData({
                ...this.metadata,
                module: this.module,
            });
            _css = ConsoleLogger.buildMetaDataCss(this.config.colors[type]);
            _reportCss = ConsoleLogger.buildReportCss();
            const output = `%c${ConsoleLogger.getTimeStamp()} ${type
                .toUpperCase()
                .padEnd(6)}`;
            console.log(`%c${_metaData}`, _css);
            console.log(output, _css);
            console.log(`%c${_report}`, _reportCss);
        }
    }
    static pad(time) {
        return time.padStart(2, '0');
    }
    static getTimeStamp() {
        const date = new Date();
        const hours = ConsoleLogger.pad(date.getHours().toString());
        const minutes = ConsoleLogger.pad(date.getMinutes().toString());
        const secs = ConsoleLogger.pad(date.getSeconds().toString());
        const milliseconds = ConsoleLogger.pad(date.getMilliseconds().toString());
        return `${hours}:${minutes}:${secs}:${milliseconds}`;
    }
    static buildMetaData(metaData) {
        const { project, projectVersion, app, appVersion, module } = metaData;
        const _str = `${project}-${projectVersion} | ${app}-${appVersion} | ${module}`;
        return _str;
    }
    static buildMetaDataCss(color) {
        const _css = `color: #fff;font-weight:bold; background-color: ${color}; padding: 3px 3px;`;
        return _css;
    }
    static buildReportCss() {
        const _css = `color: #fff;font-weight:bold; background-color: #000; padding: 3px 3px;`;
        return _css;
    }
    static echo(message, data) {
        return data || message;
    }
}
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=logger-console.js.map